import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateCustomerReportRequest,
  CustomerReport,
  CustomerReportLinesListResponse,
  ReportedCustomersFilterParams,
} from '@models/products-and-orders/customer-reports';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CustomerReportsService {
  private readonly url = `${environment.bffUrl}/customer-reports`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<CustomerReport[]> {
    return this.httpClient.get<CustomerReport[]>(this.url);
  }

  getOne(id: string): Observable<CustomerReport> {
    return this.httpClient.get<CustomerReport>(`${this.url}/${id}`);
  }

  add(req: CreateCustomerReportRequest): Observable<CustomerReport> {
    return this.httpClient.post<CustomerReport>(this.url, req);
  }

  getAutoSubmitDayOfMonth(): Observable<{ autoSubmitDayOfMonth: number }> {
    return this.httpClient.get<{ autoSubmitDayOfMonth: number }>(`${this.url}/auto-submit-day-of-month`);
  }

  getLines(params: ReportedCustomersFilterParams): Observable<CustomerReportLinesListResponse> {
    return this.httpClient.get<CustomerReportLinesListResponse>(`${this.url}/lines`, { params });
  }
}
